export const ACTIVITY_AUDIENCE_TYPES = {
    TEAM: 1,
    ATHLETE: 2,
    NEW_ATHLETES: 3
};
